import { Button, cn, Separator, Table } from 'twyne-new.ui';

import { useGrid } from '@Components/Grid/context';

import Pagination from "./Pagination";

export default function TableWrapper({ children, hadResized }) {
  return <>
    <ActionsCheckboxes />
    <Table className={cn('w-full min-w-full', hadResized && 'table-fixed')} containerClassName='pl-2'>
      {children}
    </Table>
    <Pagination />
  </>
}

function ActionsCheckboxes() {
  const { rowsSelected, definitions } = useGrid()
  const { entityNamePlural, entityName } = definitions
  const selectedCount = rowsSelected.length
  const showBulkHeader = selectedCount > 0

  return <div className={cn(
    'w-full flex items-center px-5 gap-2 overflow-hidden transition-all duration-200 ease-in-out',
    showBulkHeader ? 'max-h-14 py-3 opacity-100 translate-y-0 border-b twy-border-base' : 'max-h-0 py-0 opacity-0 -translate-y-1 border-b border-transparent pointer-events-none')
  }>
    <span className='twy-text-base-accent'>Edit Selected</span>
    <Button variant='outline' size='sm'>Active</Button>
    <Separator orientation='vertical' className='py-2' />
    <div>
      <span className='twy-text-base-accent mr-1'>{selectedCount}</span>
      <span>{rowsSelected.length === 1 ? entityName : entityNamePlural} selected.</span>
    </div>
  </div>
}
